import { isAddressEqual } from 'viem';
export class OneInchSingleChainSDK {
    static { this.instance = new Map(); }
    constructor(appContext) {
        this.appContext = appContext;
    }
    async getInstance(chain) {
        let sdk = OneInchSingleChainSDK.instance.get(chain);
        if (!sdk) {
            sdk = await buildFusionSDK(this.appContext.isEmbedded ? '/' : '/proxy/direct/fusion', chain, this.appContext.wallet, this.appContext.onChain, this.appContext.api.getProxyClient());
            OneInchSingleChainSDK.instance.set(chain, sdk);
        }
        return sdk;
    }
}
async function buildFusionSDK(host, chain, walletController, onChain, proxyClient) {
    const { FusionSDK } = await import('@1inch/fusion-sdk');
    return new FusionSDK({
        url: host,
        network: chain.valueOf(),
        httpProvider: proxyClient,
        blockchainProvider: {
            signTypedData: async (walletAddress, typedData) => {
                const activeWalletAddress = await walletController.data.getActiveAddress();
                if (!activeWalletAddress || !isAddressEqual(activeWalletAddress, walletAddress)) {
                    throw new Error('');
                }
                return await walletController.signTypedData(typedData);
            },
            ethCall: async (address, callData) => {
                const client = await onChain.getClient(chain);
                const result = await client.call({
                    to: address,
                    data: callData,
                });
                return result.data ?? '';
            },
        },
    });
}
//# sourceMappingURL=1inch-single-chain-sdk.js.map